import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  useDisclosure,
} from "@heroui/react";
import { ActualPayment } from "@/api/analytics";
import { getBillingType, summaryValue } from "@/utils";

export function PromptPaymentModal({
  disclosure,
  payments,
  selectPayment,
  createPayment,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
  payments: ActualPayment[] | undefined;
  selectPayment: (bill: ActualPayment) => void;
  createPayment: () => void;
}) {
  return (
    <>
      <Modal
        isOpen={disclosure.isOpen}
        onOpenChange={disclosure.onOpenChange}
        portalContainer={document.getElementById("main")!}
        backdrop="blur"
        scrollBehavior="outside"
        size="4xl"
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader>
                <div className="w-full items-center flex flex-row justify-between gap-2">
                  <span>Выберите платёж</span>
                  <Button
                    variant="flat"
                    color="default"
                    onClick={createPayment}
                  >
                    Создать платёж
                  </Button>
                </div>
              </ModalHeader>
              <ModalBody>
                <div className="grid grid-cols-2 gap-2">
                  {payments && (
                    <>
                      {payments.map((payment, index) => (
                        <div
                          className="flex flex-col bg-background border-2 border-default-200 rounded-xl cursor-pointer select-none p-4"
                          key={index}
                          onClick={() => selectPayment(payment)}
                        >
                          <span>
                            {payment.billing_number} - {payment.office_name}
                          </span>
                          <span>{getBillingType(payment.billing_type)}</span>
                          <span>{summaryValue(payment.total_paid || 0)}р.</span>
                        </div>
                      ))}
                    </>
                  )}
                </div>
              </ModalBody>
              <ModalFooter>
                <Button variant="flat" color="default" onClick={onClose}>
                  Закрыть
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
